import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import { BillLineItem } from "@common/types/bill";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { DocumentMatchCellContent } from "@components/accounting/transactionMatch/DocumentMatchCellContent";
import { useBillMatchCellProps } from "../../useBillMatchCellProps";

export const MatchCell = memo(
    ({ row, table }: CellContext<ViewTableFeatures, BillLineItem, unknown>) => {
        const matchProps = useBillMatchCellProps({
            billId: row.original.billId,
            table,
        });
        return <DocumentMatchCellContent {...matchProps} />;
    },
);
MatchCell.displayName = "BillLineItemMatchCell";
